module.exports = __webpack_public_path__ + "media/images/iconbox/icon5-5266a6fdcf25dc294cd41c8daeb87a81.png";